import { zodResolver } from '@hookform/resolvers/zod';
import { type UseFormProps, useForm } from 'react-hook-form';

import {
	type AiSearchSchemaProps,
	aiSearchSchema
} from '@/schemas/aiSearch/schema';

export const useAiSearchFormValidation = (
	props?: UseFormProps<AiSearchSchemaProps>
) =>
	useForm<AiSearchSchemaProps>({
		resolver: zodResolver(aiSearchSchema),
		defaultValues: {
			filters: ''
		},
		...props
	});
